import Bowser from 'bowser';

const parser = Bowser.getParser(window.navigator.userAgent);

export const browserName = parser.getBrowserName();
export const osName = parser.getOSName();
